import type { NamedUser } from "./user";

export type Parent = NamedUser & {
  id: number | null;
  salutation?: string;
  email: string;
  phone: string;
};

export const emptyParent = {
  id: null,
  salutation: undefined,
  last_name: "",
  first_name: "",
  email: "",
  phone: "",
} as const satisfies Parent;
